import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import type { IngredientsInfoContent } from '../../Ingredients';

export const AZELAIC: IngredientsInfoContent = {
  name: 'azelaic',
  title: 'Azelaic Acid',
  detailsText:
    'A multitasking exfoliant that helps unclog pores, smooth texture, and brighten skin.',
  iconImage: (
    <StaticImage
      src="../../images/azelaic@2x.png"
      width={80}
      alt="azelaic acid"
    />
  ),
};

export const NIACINAMIDE: IngredientsInfoContent = {
  name: 'niacinamide',
  title: 'Niacinamide',
  detailsText:
    'A form of vitamin B3 that soothes inflammation, fades dark spots, and fights free radicals.',
  iconImage: (
    <StaticImage
      src="../../images/niacinamide@2x.png"
      width={80}
      alt="niacinamide"
    />
  ),
};

export const CLINDAMYCIN: IngredientsInfoContent = {
  name: 'clindamycin',
  title: 'Clindamycin',
  detailsText:
    'An antibiotic that fights acne-contributing bacteria and soothes inflammation.',
  iconImage: (
    <StaticImage
      src="../../images/clindamycin@2x.png"
      width={80}
      alt="clindamycin"
    />
  ),
};

export const METRONIDAZOLE: IngredientsInfoContent = {
  name: 'metronidazole',
  title: 'Metronidazole',
  detailsText:
    'An antibiotic that can help soothe inflammation, including redness and swelling.',
  iconImage: (
    <StaticImage
      src="../../images/metronidazole@2x.png"
      width={80}
      alt="metronidazole"
    />
  ),
};

export const TRETINOIN: IngredientsInfoContent = {
  name: 'tretinoin',
  title: 'Tretinoin',
  detailsText:
    'A vitamin A derivative that helps clear acne and smooth out texture and can improve dark spots and fine lines.',
  iconImage: (
    <StaticImage
      src="../../images/tretinoin@2x.png"
      width={80}
      alt="tretinoin"
    />
  ),
};

export const ZINC: IngredientsInfoContent = {
  name: 'zinc',
  title: 'Zinc Pyrithione',
  detailsText:
    'An antimicrobial that helps keep acne-contributing bacteria and fungi in check.',
  iconImage: (
    <StaticImage
      src="../../images/zinc@2x.png"
      width={80}
      alt="zinc pyrithione"
    />
  ),
};

export const TRANEXAMIC: IngredientsInfoContent = {
  name: 'tranexamic',
  title: 'Tranexamic Acid',
  detailsText:
    'A brightening amino acid derivative that helps lighten dark spots and reduce redness.',
  iconImage: (
    <StaticImage
      src="../../images/tranexamic@2x.png"
      width={80}
      alt="tranexamic acid"
    />
  ),
};

export const MINOXIDIL: IngredientsInfoContent = {
  name: 'minoxidil',
  title: 'Minoxidil',
  detailsText:
    'Stimulates blood flow to hair follicles and extends the growth phase of hair—ultimately boosting hair growth.',
  iconImage: (
    <StaticImage
      src="../../images/minoxidil@2x.png"
      width={80}
      alt="minoxidil"
    />
  ),
  disclaimer:
    'Active ingredients subject to consultation. Do not use if pregnant, breastfeeding, or trying conceive. Inactive ingredients: Ethyl Alcohol, Propanediol, Purified Water. Formulas that contain minoxidil also contain lactic acid.',
};

export const FINASTERIDE: IngredientsInfoContent = {
  name: 'finasteride',
  title: 'Finasteride',
  detailsText:
    'Counteracts the effects of DHT (a hormone that plays a major role in hair loss), supports hair regrowth, and helps prevent hair loss.',
  iconImage: (
    <StaticImage
      src="../../images/finasteride@2x.png"
      width={80}
      alt="finasteride"
    />
  ),
  disclaimer:
    'Active ingredients subject to medical consultation. Inform your medical provider of your pregnancy status. Do not handle if pregnant, breastfeeding, or any chance you may become pregnant. Inactive ingredients: Ethyl Alcohol, Propanediol, Purified Water. Formulas that contain minoxidil also contain lactic acid.',
};

export const DUTASTERIDE: IngredientsInfoContent = {
  name: 'dutasteride',
  title: 'Dutasteride',
  detailsText:
    'Helps to prevent hair loss by interfering with the production of DHT (a hormone that plays a major role in hair loss), while promoting regrowth.',
  iconImage: (
    <StaticImage
      src="../../images/dutasteride@2x.png"
      width={80}
      alt="dutasteride"
    />
  ),
};

export const KETOCONAZOLE: IngredientsInfoContent = {
  name: 'ketoconazole',
  title: 'Ketoconazole',
  detailsText:
    'Antifungal that treats dandruff, while also stimulating hair regrowth.',
  iconImage: (
    <StaticImage
      src="../../images/ketoconazole@2x.png"
      width={80}
      alt="ketoconazole"
    />
  ),
};

export const SPIRONOLACTONE: IngredientsInfoContent = {
  name: 'spironolactone',
  title: 'Spironolactone',
  detailsText:
    'Helps to protect hair from DHT (a hormone that plays a major role in hair loss), while restoring hair fullness and helping prevent progressive hair loss.',
  iconImage: (
    <StaticImage
      src="../../images/spironolactone@2x.png"
      width={80}
      alt="spironolactone"
    />
  ),
  disclaimer:
    'Active ingredients subject to medical consultation. Do not use if pregnant, breastfeeding, or trying conceive. Inactive ingredients: Ethyl Alcohol, Propanediol, Purified Water. Formulas that contain minoxidil also contain lactic acid.',
};

export const CAFFEINE: IngredientsInfoContent = {
  name: 'caffeine',
  title: 'Caffeine',
  detailsText:
    'Stimulates the hair follicle and extends the growth phase of hair.',
  iconImage: (
    <StaticImage src="../../images/caffeine@2x.png" width={80} alt="caffeine" />
  ),
};

export const MELATONIN: IngredientsInfoContent = {
  name: 'melatonin',
  title: 'Melatonin',
  detailsText:
    'Antioxidant that counteracts free radicals, which can impair hair follicle function and lead to hair loss.',
  iconImage: (
    <StaticImage
      src="../../images/melatonin@2x.png"
      width={80}
      alt="melatonin"
    />
  ),
};

export const DEXPANTHENOL: IngredientsInfoContent = {
  name: 'dexpanthenol',
  title: 'Dexpanthenol',
  detailsText:
    'A vitamin B5 derivative that attracts and holds moisture for softer, smoother skin',
  iconImage: (
    <StaticImage
      src="../../images/dexpanthenol@2x.png"
      width={80}
      alt="melatonin"
    />
  ),
};

export const ACNE_ROSACEA = 'Acne / Rosacea';
export const ANTI_AGING = 'Anti-Aging';
export const ANTI_AGING_FUTURE_PROOF = 'Anti-Aging Future Proof';
export const DARK_SPOTS = 'Dark Spots';
export const HAIR_LOSS = 'Hair Loss';

export type SkincareConcern =
  | typeof ACNE_ROSACEA
  | typeof ANTI_AGING
  | typeof ANTI_AGING_FUTURE_PROOF
  | typeof DARK_SPOTS
  | typeof HAIR_LOSS;

export const INGREDIENTS: Record<SkincareConcern, IngredientsInfoContent[]> = {
  [ACNE_ROSACEA]: [
    AZELAIC,
    NIACINAMIDE,
    CLINDAMYCIN,
    METRONIDAZOLE,
    TRETINOIN,
    ZINC,
    TRANEXAMIC,
  ],
  [ANTI_AGING]: [
    TRETINOIN,
    AZELAIC,
    NIACINAMIDE,
    CLINDAMYCIN,
    METRONIDAZOLE,
    ZINC,
    TRANEXAMIC,
  ],
  [ANTI_AGING_FUTURE_PROOF]: [
    TRETINOIN,
    AZELAIC,
    NIACINAMIDE,
    TRANEXAMIC,
    DEXPANTHENOL,
  ],
  [DARK_SPOTS]: [TRANEXAMIC, TRETINOIN, AZELAIC, NIACINAMIDE],
  [HAIR_LOSS]: [
    MINOXIDIL,
    FINASTERIDE,
    KETOCONAZOLE,
    SPIRONOLACTONE,
    CAFFEINE,
    MELATONIN,
  ],
};
